import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { StyledCardContent, StyledQuickLoadingCard } from "./styles";

export const QuickActionLoadingCard = () => (
    <StyledQuickLoadingCard>
        <PixelPlaceholderLoader
            width="24px"
            height="24px"
        />
        <StyledCardContent>
            <PixelPlaceholderLoader
                width="120px"
                height="14px"
            />
            <PixelPlaceholderLoader
                width="184px"
                height="14px"
            />
        </StyledCardContent>
    </StyledQuickLoadingCard>
);
